import { useEffect } from "react";
import { Link, Element, Events, scrollSpy, scroller } from "react-scroll";
import Footer2 from "./Footer2";
import Sponsorship from "./Sponsorship.js";
import Flowchart from "./Flowchart";
import "./Landing.css";
import ScrollDown from "./ScrollDown";
import SC from "./SC";
import "./SlideShow.css";
import TextType from "./TextType.js";
import DomeGallery from "./DomeGallery";

function App() {
  useEffect(() => {
    scrollSpy.update();
    
    // Optional: Listen for scroll end to update spy
    const handleScrollEnd = () => scrollSpy.update();
    Events.scrollEvent.register("end", handleScrollEnd);
    
    return () => {
      Events.scrollEvent.remove("end", handleScrollEnd);
    };
  }, []);

  return (
    <div className="app-container">
      <TextType
        text={["MAFFICK x TECHNOSEARCH"]}
        typingSpeed={75}
        pauseDuration={1500}
        showCursor={true}
        cursorCharacter="|"
        className="text"
      />

      {/* Dome + ScrollDown positioned LEFT */}
      <Link
        to="flowchart-section"
        smooth={true}
        duration={800}
        offset={-60}
        className="scroll-down-left"
      >
        <button
          style={{
            width: "15vw",
            height: "20vh",
            minWidth: "20vw",
            minHeight: "20vh",
            position:"relative",
            top:"10vh",
            color:"white"
          }}
        >
          <ScrollDown />
        </button>
      </Link>

      <div className="dome-wrapper">
        <div
          style={{ width: "100vw", height: "100vh", paddingTop: "10vh" }}
          className="dome"
        >
          <DomeGallery />
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      {/* ✅ Scroll target */}
      <Element name="flowchart-section">
        <Flowchart />
      </Element>

      <SC />
      <br />
      <br />
      <p style={{ fontFamily: "Oswald", padding: "50px", fontSize: "25pt" }}>
        OUR SPONSORS
      </p>
      <Sponsorship />
      <Footer2 />
    </div>
  );
}

export default App;
